<template>
  <div class="loader">
    <UIcon name="i-lucide-loader-2" class="loader__icon" />
    <span class="loader__text">Загрузка заметок...</span>
  </div>
</template>

<style lang="scss">
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  &__icon {
    font-size: 1.5rem;
    color: var(--color-gray-500);
    animation: var(--animate-spin);
  }
  &__text {
    margin-left: 0.5rem;
    color: var(--color-gray-500);
  }
}
</style>
